export const routeMap = {
  home: {
    'com.br': 'https://bycoders.com.br/',
    'pt': 'https://bycoders.pt/',
    'us': 'https://bycoders.us/',
    'co': 'https://bycoders.co/'
  },

  articles: {
    'com.br': 'https://bycoders.com.br/articles',
    'pt': 'https://bycoders.pt/artigos',
    'us': 'https://bycoders.us/articles',
    'co': 'https://bycoders.co/articles'
  },

  article: {
    'com.br': 'https://bycoders.com.br/article',
    'pt': 'https://bycoders.pt/artigo',
    'us': 'https://bycoders.us/article',
    'co': 'https://bycoders.co/article'
  },

  cases: {
    'com.br': 'https://bycoders.com.br/cases',
    'pt': 'https://bycoders.pt/casos',
    'us': 'https://bycoders.us/cases',
    'co': 'https://bycoders.co/cases'
  },

  case: {
    'com.br': 'https://bycoders.com.br/case',
    'pt': 'https://bycoders.pt/caso',
    'us': 'https://bycoders.us/case',
    'co': 'https://bycoders.co/case'
  },

  about: {
    'com.br': 'https://bycoders.com.br/about',
    'pt': 'https://bycoders.pt/sobre',
    'us': 'https://bycoders.us/about',
    'co': 'https://bycoders.co/about'
  },

  services: {
    'com.br': 'https://bycoders.com.br/services',
    'pt': 'https://bycoders.pt/servicos',
    'us': 'https://bycoders.us/services',
    'co': 'https://bycoders.co/services'
  },

  careers: {
    'com.br': 'https://bycoders.com.br/careers',
    'pt': 'https://bycoders.pt/carreiras',
    'us': 'https://bycoders.us/careers',
    'co': 'https://bycoders.co/careers'
  },

  vacancy: {
    'com.br': 'https://bycoders.com.br/careers/vacancy',
    'pt': 'https://bycoders.pt/carreiras/vaga',
    'us': 'https://bycoders.us/careers/vacancy',
    'co': 'https://bycoders.co/careers/vacancy'
  },

  contact: {
    'com.br': 'https://bycoders.com.br/contact',
    'pt': 'https://bycoders.pt/contato',
    'us': 'https://bycoders.us/contact',
    'co': 'https://bycoders.co/contact'
  },

  privacyPolicy: {
    'com.br': 'https://bycoders.com.br/privacy-police',
    'pt': 'https://bycoders.pt/politica-de-privacidade',
    'us': 'https://bycoders.us/privacy-policy',
    'co': 'https://bycoders.co/privacy-policy'
  }
};
